import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import Carousel from '../../../../../../../../components/Banners/components/CarouselBanner'

import './style.scss'

@injectIntl
export default class CarouselBanner extends PureComponent {
    static propTypes = {
        intl: PropTypes.object.isRequired,
        onClick: PropTypes.func,
    }

    static defaultProps = {
        onClick: () => {},
    }

    constructor(props) {
        super(props)

        this._carouselConfiguration = [
            {
                text: props.intl.formatMessage({ id: `${LOCALE_PREFIX}.text.detrimentalEvents` }),
                image: 'detrimentalEvents.png',
            },
            {
                text: props.intl.formatMessage({ id: `${LOCALE_PREFIX}.text.scoring` }),
                image: 'scoring.png',
            },
            {
                text: props.intl.formatMessage({ id: `${LOCALE_PREFIX}.text.regionRisk` }),
                image: 'regionRisk.png',
            },
            {
                text: props.intl.formatMessage({ id: `${LOCALE_PREFIX}.text.companyHeadquarters` }),
                image: 'companyHeadquarters.png',
            },
        ]
    }

    render() {
        const { onClick } = this.props

        return (
            <div className={'portfolio-carousel-banner-block'}>
                <div className={'header'}>
                    <div className={'text'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.header`} />
                    </div>
                </div>
                <div className={'title'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.title.start`} />
                    <span className={'link'} onClick={onClick}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.title.link`} />
                    </span>
                    <FormattedMessage id={`${LOCALE_PREFIX}.title.end`} />
                </div>
                <Carousel id={'portfolio_carousel'} configuration={this._carouselConfiguration} />
                <div className={'footer'}>
                    <div className={'help'}>
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.contact`}
                            values={{
                                atel: (chunks) => <a href="tel:+420274000800">{chunks}</a>,
                                amail: (chunks) => <a href="mailto:podpora.cz@dnb.com">{chunks}</a>,
                            }}
                        />
                    </div>
                    <div className={'button-wrap'}>
                        <div className={'find-out-more-button'} onClick={onClick}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.button`} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
